import React, { useState,useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button,Label,Input,Modal,ModalHeader } from 'reactstrap';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios'

export default function Newclaim() {
    const [search, setSearch] = useState('')
    const [progress, setProgress] = useState(1)
    const [litigation, setLitigation] = useState('NO')
    const [account, setAccount] = useState("");
    const [reg, setReg] = useState('');
    const [driver,setDriver] = useState('');
    const [driverID, setDriverid] = useState('');
    const [place, setPlace] = useState('');
    const [claimant, setClaimant] = useState('');
    const [caseNumber, setCasenumber] = useState('');
    const [lawyer, setLawyer] = useState('');
    const [courtNumber, setCourtnumber] = useState('');
    const [magistrate, setMagistrate] = useState('')
    const [police, setPolice] = useState('')
    const [underwriter1, setUnderwriter1] = useState('')
    const [underwriter2, setUnderwriter2] = useState('')
    const [underwriter3, setUnderwriter3] = useState('')
    const [occurenceDate, setOccurencedate] = useState('')
    const [modal, setModal] = useState(false)
    const [modal2, setModal2] = useState(false)
    const [owner, setOwner] = useState('');
    const [ownerID, setOwnerid] = useState('');
    const [ownerPhone, setOwnerphone] = useState('')
    const [lawyerPhone, setLawyerphone] = useState('');
    const [driverPhone, setDriverphone] = useState('');
    const [policePhone, setPolicephone] = useState('');
    const [claimantPhone, setClaimantphone] = useState('')
    const [claimantID, setClaimantID] = useState('');
    const [claimValue, setClaimvalue] = useState('');
    const [caseProgress, setCaseprogress] = useState('');
    const [award, setAward] = useState('');
    const [auctioneer, setAuctioneer] = useState('')
    const [lawfirm, setLawfirm] = useState('')
    const [proclamation, setProclamation] = useState('')
    const [submitText, setSubmittext] = useState('Submit information')
    const navigate = useNavigate();
    const [sendOtp, setSendotp] = useState(1);
    const [otp, setOPT] = useState('');
    const [code, setCode] = useState('');
    const [sendOtptext, setSendotptext] = useState('SEND OTP');
    const [file, setFile] = useState(null);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
    const [policyNumber, setPolicynumber] = useState('');
    const [policyClass, setPolicyclass] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [vehicleValue, setValuevehicle] = useState('')
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [attachmentDate, setAttachmentdate] = useState('');
    const [releaseDate, setReleasedate] = useState('');
    const [estimatedLoss, setEstimatedloss] = useState('');
    const [vehicleStatus, setVehicleStatus] = useState('');
    const [mpesaNumber, setMpesanumber] = useState("");
    const [payText, setPaytext] = useState('Submit')
    const [isPay, setIspay] = useState(0)
    const [policeStation, setPolicestation] = useState('')
    const [sellingPrice, setSellingprice] = useState("")
    const [KRAPin, setKRAPin] = useState('')


    const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChange2 = (event) => {
    setIsChecked2(event.target.checked);
  };

    const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

    const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileChange2 = (e) => {
    setFile2(e.target.files[0]);
  };
  const handleFileChange3 = (e) => {
    setFile3(e.target.files[0]);
  };

  const handleSubmit = async (e) => {

    if (!account || !file) {

      return;
    }

    const formData = new FormData();
    formData.append('email', account);
    formData.append('file', file);

    try {
      const response = await Axios.post('https://panel.yunshuglobal.com:3063/api/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });


    } catch (error) {
  
      console.error(error);
    }
  };

  const handleSubmit2 = async (e) => {

if (!account || !file2) {

  return;
}

const formData = new FormData();
formData.append('email', account);
formData.append('file', file2);

try {
  const response = await Axios.post('https://panel.yunshuglobal.com:3063/api/upload2', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });


} catch (error) {

  console.error(error);
}
};

const handleSubmit3 = async (e) => {

if (!account || !file3) {

  return;
}

const formData = new FormData();
formData.append('email', account);
formData.append('file', file3);

try {
  const response = await Axios.post('https://panel.yunshuglobal.com:3063/api/upload3', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });


} catch (error) {

  console.error(error);
}
};
    

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setOccurencedate(millisecondsSinceEpoch);
    
      };

      const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setReleasedate(millisecondsSinceEpoch);
    
      };

      const handleDateChange3 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setAttachmentdate(millisecondsSinceEpoch);
    
      };
      const toggle=()=>{
        setModal(!modal)
      }

    useEffect(() => {
        const user = localStorage.getItem('email'); // Retrieve email
        if (user) {
          setAccount(user)
        } else {
       
        }
      }, []);

      


      const submitInformation=async()=>{


        
            setSubmittext('Please wait...')
           
            const res = await fetch('https://panel.yunshuglobal.com:3063/api/submitClaim',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({reg,driver,driverID,place,claimant,occurenceDate,caseNumber,police,lawyer,courtNumber,magistrate,underwriter1,underwriter2,underwriter3,account,lawfirm,driverPhone,lawyerPhone,owner,ownerID,ownerPhone,policePhone,claimantID,claimantPhone,claimValue,caseProgress,award,proclamation,auctioneer,policyNumber,policyClass,policeStation,vehicleStatus:isChecked2,attachmentDate,releaseDate,estimatedLoss,vehicleValue,sellingPrice,isPay,KRAPin}),
            credentials:"include"
        })

        const data = await res.json();
        const {success} = data;

        if(success == true){
            handleSubmit();
            handleSubmit2();
            handleSubmit3();
            toast.success('Information submitted')
            setSubmittext('Submit')
            setModal(false)
            setModal2(false)
            setReg('');
            setDriver('');
            setDriverid('');
            setPlace('');
            setClaimant('');
            setOccurencedate('');
            setPolice('');
            setCasenumber('');
            setLawyer('');
            setCourtnumber('');
            setMagistrate('');
            setUnderwriter1('');
            setUnderwriter2('');
            setUnderwriter3('')
            setProgress(1)
            setLitigation('NO')
            setLawfirm('')
            setDriverphone('');
            setOwner('');
            setOwnerid('')
            setOwnerphone('')
            setLawyerphone('');
            setClaimantID('');
            setClaimantphone('');
            setClaimvalue('');
            setCaseprogress('');
            setAward('');
            setKRAPin('')
            setProclamation('')
            setAuctioneer('')
            setSendotp(1)
            navigate('/dashboard')
        }
        else{
            setSubmittext('Submit information')
            toast.error('Something went wrong!')
        }
        
 
      }


      const toHome=()=>{
        navigate('/dashboard')
      }
      const toReport=()=>{
        navigate('/report')
      }

      const logout=()=>{
        localStorage.removeItem('email');
        navigate('/login')
      }


      const triggerOTP =async()=>{
        if(ownerPhone){
            setSendotptext('Please wait...')
            const randomCode = Math.floor(100000 + Math.random() * 900000); // generates a number between 100000 and 999999
            setCode(randomCode);
            const formattedPhone= '254' + ownerPhone.slice(1);
            const res = await Axios.post('https://n8n.yunshuafrica.com/webhook/8358e0bf-620b-43cc-be82-b81bc9104260',{formattedPhone,randomCode});
            setSendotp('SEND OTP')
        

            setSendotp(2)
        }
      }

      const validateOTP =()=>{
        if(otp == code){
            toast.success('Validated');
            setSendotp(3)
        }
        else{
            toast.success('Incorrect OTP')
            
        }
      }

      const step2 =()=>{
        if(reg && owner && ownerID && ownerPhone && claimant && claimValue){
            setProgress(2)
        }
        else{
            toast.error('All fields marked * are required!')
        }
      }

      const step3=()=>{
        if(litigation == 'YES'){
            setProgress(3)

           
            
        }
        else if(litigation == 'NO'){
            setProgress(3)
        }
      }

      const preview=()=>{
        if(policyNumber && underwriter1){
            toggle()
        }
        else{
            toast.error('All fields marked * are required!')
        }
      }


      const handleClaimValueChange = (e) => {
        // Remove any non-numeric characters except for the decimal point
        let value = e.target.value.replace(/[^0-9.]/g, '');
    
        // If there is a decimal point, only keep one
        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
    
        // Format the value as currency (with commas)
        value = Number(value).toLocaleString();
    
        // Set the formatted value
        setClaimvalue(value)
      };

      const handleVehicleValueChange = (e) => {
        // Remove any non-numeric characters except for the decimal point
        let value = e.target.value.replace(/[^0-9.]/g, '');
    
        // If there is a decimal point, only keep one
        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
    
        // Format the value as currency (with commas)
        value = Number(value).toLocaleString();
    
        // Set the formatted value
        setValuevehicle(value)
      };
      const handleAwardChange = (e) => {
        // Remove any non-numeric characters except for the decimal point
        let value = e.target.value.replace(/[^0-9.]/g, '');
    
        // If there is a decimal point, only keep one
        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
    
        // Format the value as currency (with commas)
        value = Number(value).toLocaleString();
    
        // Set the formatted value
        setAward(value)
      };

      const handleSellingChange = (e) => {
        // Remove any non-numeric characters except for the decimal point
        let value = e.target.value.replace(/[^0-9.]/g, '');
    
        // If there is a decimal point, only keep one
        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
    
        // Format the value as currency (with commas)
        value = Number(value).toLocaleString();
    
        // Set the formatted value
        setSellingprice(value)
      };

      const handleEstimatedloss = (e) => {
        // Remove any non-numeric characters except for the decimal point
        let value = e.target.value.replace(/[^0-9.]/g, '');
    
        // If there is a decimal point, only keep one
        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
    
        // Format the value as currency (with commas)
        value = Number(value).toLocaleString();
    
        // Set the formatted value
        setEstimatedloss(value)
      };
  return (
    <div>
        <ToastContainer />
        <div className="homeTop2">
            <div className="menuBar">
                <h4 className='menuTitle'>Motor Claims Database</h4>
                <div className="menuList">
              
                    <p className='menu' onClick={toHome}>All Claims</p>
                    <p className='menu'>New Claim</p>
                    <p className='menu' onClick={toReport} >Reports</p>
                    <p className='menu' onClick={logout} >Sign Out</p>
                </div>
                <div className="phoneMenu">
                    <header className='header'>
                        <div className="menu-icon" onClick={toggleMenu}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        </div>

                        <nav className={`nav-menu ${isOpen ? 'open' : ''}`}>
                        <ul>
                            <li onClick={toHome}><a>My Claims</a></li>
                            <li><a>New Claim</a></li>
                            <li  onClick={toReport}><a>Reports</a></li>
                            <li onClick={logout}><a>Sign out</a></li>
                        </ul>
                        </nav>
                    </header>
                </div>
            </div>
            {/* <div className="searchContainer">
                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search" onChange={(e)=>{setSearch(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
                </FloatingLabel>
                <Button color='info' className='searchButton' >SEARCH</Button>

            </div> */}
           

        </div>
        <div className="homeContainer">
           <h5>Register new claim</h5>
            <hr />
            <div className="registrationContainer">
                <div className="registrationLeft">
                    {progress ==1 &&
                    <>
                    <h6>Step 1 - Basic information</h6>
                    <div className="entries">
                        <div className="entryRow">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle registration*" onChange={(e)=>{setReg(e.target.value)}}>
                                <Form.Control value={reg}  className='inputSearch'   type="text" placeholder="KAA123A" />
                            </FloatingLabel>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle owner*" onChange={(e)=>{setOwner(e.target.value)}}>
                                <Form.Control value={owner}  className='inputSearch'   type="text" placeholder="Vehicle owner" />
                            </FloatingLabel>

                        </div>
                        <div className="entryRow">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle Owner ID*" onChange={(e)=>{setOwnerid(e.target.value)}}>
                            <Form.Control value={ownerID}  className='inputSearch'   type="text" placeholder="Owner ID" />
                        </FloatingLabel>

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle Owner KRA pin" onChange={(e)=>{setKRAPin(e.target.value)}}>
                            <Form.Control value={KRAPin}  className='inputSearch'   type="text" placeholder="e.g A01018273F" />
                        </FloatingLabel>
                        </div>
                        <div className="entryRow">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Vehicle Owner phone number*" onChange={(e)=>{setOwnerphone(e.target.value)}}>
                            <Form.Control value={ownerPhone}  className='inputSearch'   type="text" placeholder="e.g 0712345678" />
                        </FloatingLabel>
                        </div>

                       

                        <div className="entryRow">

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Driver name" onChange={(e)=>{setDriver(e.target.value)}}>
                            <Form.Control value={driver}  className='inputSearch'   type="text" placeholder="Driver name" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Driver ID" onChange={(e)=>{setDriverid(e.target.value)}} >
                            <Form.Control value={driverID}  className='inputSearch'   type="text" placeholder="Driver ID" />
                        </FloatingLabel>

                        </div>
                        <div className="entryRow">

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Location of incident" onChange={(e)=>{setPlace(e.target.value)}}>
                            <Form.Control value={place}  className='inputSearch'   type="text" placeholder="Location of incident" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Claimant name*" onChange={(e)=>{setClaimant(e.target.value)}}>
                        <Form.Control value={claimant} className='inputSearch'   type="text" placeholder="Claimant name*" />
                        </FloatingLabel>

                        </div>
                        <div className="entryRow">

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Claimant ID" onChange={(e)=>{setClaimantID(e.target.value)}}>
                        <Form.Control value={claimantID}  className='inputSearch'   type="text" placeholder="Claimant ID" />
                        </FloatingLabel>                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Claimant phone" onChange={(e)=>{setClaimantphone(e.target.value)}}>
                        <Form.Control value={claimantPhone}  className='inputSearch'   type="text" placeholder="0712345678" />
                        </FloatingLabel>

                        </div>
                        <div className="entryRow">

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Claim value*" onChange={handleClaimValueChange}>
                        <Form.Control value={claimValue}  className='inputSearch'   type="text" placeholder="Claim value*" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Value of the vehicle" onChange={handleVehicleValueChange}>
                        <Form.Control value={vehicleValue}  className='inputSearch'   type="text" placeholder="Value of the vehicle" />
                        </FloatingLabel>

                        </div>
                        <div className="entryRow">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Police Station" onChange={(e)=>{setPolicestation(e.target.value)}}>
                        <Form.Control value={policeStation}  className='inputSearch'   type="text" placeholder="Police Station" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Date of incident" onChange={handleDateChange}>
                        <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Date of incident" />
                        </FloatingLabel>

                        </div>


                        <Button color='success' onClick={step2}>Next step</Button>


  
                    </div>
                    </>
                    }


                    {progress == 2 &&
                    <>
                    <h6>Step 2 - Litigation/Court process</h6>
                    <div className="entries">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Is there litigation process?" onChange={(e)=>{setLitigation(e.target.value)}}>
                            <Form.Select  className='inputSearch'   > 
                            <option selected disabled>Is there litigation process?</option>
                            <option value='NO'>NO</option>
                            <option value='YES'>YES</option>

                            </Form.Select>
                        
                        </FloatingLabel>

                        {litigation == 'YES' &&
                            <>
                        <div className="entryRow">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Case number" onChange={(e)=>{setCasenumber(e.target.value)}}>
                                <Form.Control value={caseNumber}  className='inputSearch'   type="text" placeholder="Case number" />
                            </FloatingLabel>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Reporting police officer" onChange={(e)=>{setPolice(e.target.value)}}>
                                <Form.Control value={police}  className='inputSearch'   type="text" placeholder="Reporting police officer" />
                            </FloatingLabel>

                        </div>
                        <div className="entryRow">

                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Police officer phoner number" onChange={(e)=>{setPolicephone(e.target.value)}}>
                            <Form.Control value={policePhone}  className='inputSearch'   type="text" placeholder="Police officer phone number" />
                        </FloatingLabel>
                        
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Lawyer's name" onChange={(e)=>{setLawyer(e.target.value)}}>
                            <Form.Control value={lawyer}  className='inputSearch'   type="text" placeholder="Lawyer's name" />
                        </FloatingLabel>
                        </div>
                        <div className="entryRow">
                            
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Law firm" onChange={(e)=>{setLawfirm(e.target.value)}}>
                            <Form.Control value={lawfirm}  className='inputSearch'   type="text" placeholder="Law firm" />
                        </FloatingLabel>
                        
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Lawyer phone number" onChange={(e)=>{setLawyerphone(e.target.value)}}>
                            <Form.Control value={lawyerPhone}  className='inputSearch'   type="text" placeholder="Lawyer phone number" />
                        </FloatingLabel> 
                        </div>
                        <div className="entryRow">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Court number" onChange={(e)=>{setCourtnumber(e.target.value)}}>
                            <Form.Control value={courtNumber}  className='inputSearch'   type="text" placeholder="Court number" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Magistrate name" onChange={(e)=>{setMagistrate(e.target.value)}}>
                            <Form.Control value={magistrate}  className='inputSearch'   type="text" placeholder="Magistrate name" />
                        </FloatingLabel>
                            
                        </div>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Case stage" onChange={(e)=>{setCaseprogress(e.target.value)}}>
                        <Form.Select>
                        <option selected disabled>Select case stage</option>
                        <option value="Filling of the case">Filing of the case</option>
                        <option value="Pre-trial">Pre-trial</option>
                        <option value="Plea taking">Plea taking</option>
                        <option value="Trial">Trial</option>
                        <option value="Judgement">Judgement</option>
                        <option value="Appeal">Appeal</option>
                        </Form.Select>
                            
                           
                        </FloatingLabel>
                        {caseProgress == 'Judgement' &&
                        <>
                        <div className="entryRow">
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Award(Amount)" onChange={handleAwardChange}>
                            <Form.Control value={award}  className='inputSearch'   type="text" placeholder="Award(Amount)" />
                        </FloatingLabel>
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Proclamation" onChange={(e)=>{setProclamation(e.target.value)}}>
                            <Form.Control value={proclamation}  className='inputSearch'   type="text" placeholder="Proclamation" />
                        </FloatingLabel>
                            
                        </div>

                        <div className="entryRow">
                        <div>
                            <label>
                                <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                />
                                Attached auctioneer
                            </label>
                           
                            </div>

                        </div>
                        {isChecked &&
                        <>
                            <div className="entryRow">

                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Auctioneer name" onChange={(e)=>{setAuctioneer(e.target.value)}}>
                                <Form.Control value={auctioneer}  className='inputSearch'   type="text" placeholder="Auctioneer name" />
                            </FloatingLabel>
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Attachment date" onChange={handleDateChange3}>
                                <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Attachment date" />
                            </FloatingLabel>

                            </div>
                            <div>
                            <label>
                                <input
                                type="checkbox"
                                checked={isChecked2}
                                onChange={handleCheckboxChange2}
                                />
                               Vehicle sold
                            </label>
                           
                            </div>
                            {isChecked2 &&
                            <>
                                <div className="entryRow">
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Release date" onChange={handleDateChange2}>
                                    <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Release date" />
                                </FloatingLabel>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Selling price" onChange={handleSellingChange}>
                                    <Form.Control value={sellingPrice}  className='inputSearch'   type="text" placeholder="Selling price" />
                                </FloatingLabel>
                                

                                </div>
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Estimated income loss per day" onChange={handleEstimatedloss}>
                                    <Form.Control  value={estimatedLoss} className='inputSearch'   type="text" placeholder="Estimated income loss per day" />
                                </FloatingLabel>

                            </>
                            
                            }


                            <div className="entryRow">
                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Auctioneer Proclamation Notice"  onChange={handleFileChange2}>
                                    <Form.Control  className='inputSearch'   type="file" placeholder="Auctioneer Proclamation Notice" />
                                </FloatingLabel>

                                <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Court Warrants of Attachment"  onChange={handleFileChange3}>
                                    <Form.Control  className='inputSearch'   type="file" placeholder="Court Warrants of Attachment" />
                                </FloatingLabel>

                            </div>

                        </>

                        
                        }

                        </>
                        
                        }
                        <div className="entryRow">
                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Attach abstract*"  onChange={handleFileChange}>
                                <Form.Control  className='inputSearch'   type="file" placeholder="Attach abstract" />
                            </FloatingLabel>
                        </div>
                    
                            </>
                        
                        }

                    <Button color='success' onClick={step3}>Next step</Button>
                    <Button color='danger' onClick={()=>{setProgress(1)}} style={{marginLeft:'2%'}}>Previous step</Button>

                    </div>
                    </>
                    }


                    {progress == 3 &&
                    <>
                    <h6>Step 3 - Underwriters information</h6>
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Policy number*" onChange={(e)=>{setPolicynumber(e.target.value)}}>
                            <Form.Control value={policyNumber}  className='inputSearch'   type="text" placeholder="Policy number" />
                    </FloatingLabel>
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Policy class" onChange={(e)=>{setPolicyclass(e.target.value)}}>
                            <Form.Select  className='inputSearch'   type="text">
                            <option selected disabled>Select policy</option>
                            <option value="PSV MATATU">PSV MATATU</option>
                            <option value='Motor Private'>Motor Private</option>
                            <option value="Motor Commercial">Motor Commercial</option>
                            <option value="Tankers carrying flammable liquid">Tankers carrying flammable liquids</option>
                            <option value="Motor Trade-Road risks">Motor Trade-Road risks</option>
                            <option value="Private Hire - Chauffeur driven/Taxi Yellow Line/Online Taxi">Private Hire - Chauffeur driven/Taxi Yellow Line/Online Taxi</option>
                            <option value="Driving school vehicles">Driving school vehicles</option>
                            <option value="Instituitional Vehicles">Instituitional Vehicles</option>
                            <option value="Ambulance and Fire Fighter">Ambulance and Fire Fighter</option>
                            <option value="Motor Cycle non-psv">Motor cycle non-psv</option>
                            <option value="Motor cycle psv">Motor cycle psv</option>
                            <option value="Electronic Motor bikes">Electronic motor bikes</option>
                            <option value="Tuk Tuk Commercial">Tuk Tuk Commercial</option>
                            <option value="Tuk Tuk PSV">Tuk Tuk PSV</option>
                            <option value="Motor PSV Electric bus">Motor PSV Electic bus</option>
                            <option value="Tour Service Vehicles">Tour Service Vehicles(TSV)</option>

                            </Form.Select>
                    </FloatingLabel>

                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Insurance Company* " onChange={(e)=>{setUnderwriter1(e.target.value)}}>
                            <Form.Select  className='inputSearch'>
                                <option selected disabled>Select insurance company</option>
                               
                                <option value='AAR Insurance Company Limited'>AAR Insurance Company Limited</option>
                                <option value='Africa Merchant Assurance Company Limited'>Africa Merchant Assurance Company Limited</option>
                                <option value='AIG Kenya Insurance Company Limited'>AIG Kenya Insurance Company Limited</option>
                                <option value='APA Insurance Limited'>APA Insurance Limited</option>
                                <option value='Britam General Insurance Company (K) Limited'>Britam General Insurance Company (K) Limited</option>
                                <option value='Cannon General Insurance Company Limited'>Cannon General Insurance Company Limited</option>
                                <option value='CIC General Insurance Limited'>CIC General Insurance Limited</option>
                                <option value='Corporate Insurance Company Limited'>Corporate Insurance Company Limited</option>
                                <option value="Definite Assurance Company Limited">Definite Assurance Company Limited</option>
                                <option value='Directline Assurance Company Limited'>Directline Assurance Company Limited</option>
                                <option value='Fidelity Shield Insurance Company Limited'>Fidelity Shield Insurance Company Limited</option>
                                <option value='First Assurance Company Limited'>First Assurance Company Limited</option>
                                <option value='GA Insurance Limited'>GA Insurance Limited</option>
                                <option value='Geminia Insurance Company Limited'>Geminia Insurance Company Limited</option>
                                <option value='ICEA LION General Insurance Company Limited'>ICEA LION General Insurance Company Limited</option>
                                <option value='Intra Africa Assurance Company Limited'>Intra Africa Assurance Company Limited</option>
                                <option value='Invesco Assurance Company Limited'>Invesco Assurance Company Limited</option>
                                <option value='Jubilee Allianz General Insurance Limited'>Jubilee Allianz General Insurance Limited</option>
                                <option value='Jubilee Health Insurance Limited'>Jubilee Health Insurance Limited</option>
                                <option value='Kenindia Assurance Company Limited'>Kenindia Assurance Company Limited</option>
                                <option value='Kenya Orient Insurance Limited'>Kenya Orient Insurance Limited</option>
                                <option value='Madison General Insurance Kenya Limited'>Madison General Insurance Kenya Limited</option>
                                <option value='Mayfair Insurance Company Limited'>Mayfair Insurance Company Limited</option>
                                <option value='MUA Insurance (Kenya) Limited'>MUA Insurance (Kenya) Limited</option>
                                <option value='Occidental Insurance Company Limited'>Occidental Insurance Company Limited</option>
                                <option value='Old Mutual General Insurance Kenya Limited'>Old Mutual General Insurance Kenya Limited</option>
                                <option value='Pacis Insurance Company Limited'>Pacis Insurance Company Limited</option>
                                <option value='Pioneer General Insurance Limited'>Pioneer General Insurance Limited</option>
                                <option value='Sanlam General Insurance Company Limited'>Sanlam General Insurance Company Limited</option>
                                <option value='Star Discover Insurance Limited'>Star Discover Insurance Limited</option>
                                <option value='Takaful Insurance of Africa Limited'>Takaful Insurance of Africa Limited</option>
                                <option value='Tausi Assurance Company Limited'>Tausi Assurance Company Limited</option>
                                <option value='The Heritage Insurance Company Limited'>The Heritage Insurance Company Limited</option>
                                <option value='The Kenyan Alliance Insurance Company Limited'>The Kenyan Alliance Insurance Company Limited</option>
                                <option value='The Monarch Insurance Company Limited'>The Monarch Insurance Company Limited</option>
                                <option value='Trident Insurance Company Limited'>Trident Insurance Company Limited</option>


                            </Form.Select>
                    </FloatingLabel>
                    
                    <Button color='success' onClick={preview}>Finish</Button>
                    <Button color='danger' onClick={()=>{setProgress(2)}} style={{marginLeft:'2%'}}>Previous step</Button>
                    </>
                    
                    }

                </div>
                <div className="registrationRight">
                    <img src="/form2.png" className='formImage' alt="" />
                </div>
            </div>
            

        </div>
        <Modal isOpen={modal} toggle={toggle} size='lg'>
            <ModalHeader>Confirm information</ModalHeader>
            <div className="modalContainer">
                <div className="modalBody">
                    <div className="modalB">
                        <h6>Basic information</h6>
                        <p>Vehicle registration: {reg}</p>
                        <p>Vehicle Owner: {owner}</p>
                        <p>Owner ID: {ownerID}</p>
                        <p>Owner phone number: {ownerPhone}</p>
                        <p>Driver name: {driver}</p>
                        <p>Driver phone number: {driverPhone}</p>
                        <p>Driver ID: {driverID}</p>
                        <p>Location of incident: {place}</p>
                        <p>Claimant name: {claimant}</p>
                        <p>Claimant phone: {claimantPhone}</p>
                        <p>Claimant ID: {claimantID}</p>
                        <p>Claim value: Kes. {claimValue}</p>
                    </div>
                    {litigation == 'YES' &&
                     <div className="modalB">
                        <h6>Litigation/Court process</h6>
                        <p>Police officer: {police}</p>
                        <p>Police phone number: {policePhone}</p>
                        <p>Case number : {caseNumber}</p>
                        <p>Law firm: {lawfirm}</p>
                        <p>Lawyer name: {lawyer}</p>
                        <p>Lawyer phone number: {lawyerPhone}</p>
                        <p>Court number: {courtNumber}</p>
                        <p>Magistrate: {magistrate}</p>
                        <p>Case stage: {caseProgress}</p>
                        {caseProgress == 'Judgement' && 
                        <>
                            <p>Award: Kes. {award}</p>
                            <p>Proclamation: {proclamation}</p>
                            <p>Attached Auctioneer: {auctioneer}</p>
                        </>
                        
                        }
                        
                    </div>

                    }

                    <div className="modalB">
                        <h6>Underwriter information</h6>
                        <p>Policy class: {policyClass}</p>
                        <p>Policy number: {policyNumber}</p>
                        <p>Insurance company: {underwriter1}</p>
                        <hr />
                        <div className="mpesaDetails">
                                <img src="/mpesa.webp" alt=""  className='mpesaLogo'/>
                                <p >PAYBILL: 247 247</p>
                                <p>Account No: 667899</p>
                                <hr />
                                <p>Individual Owner: Kes. 20,000 /=</p>
                              


                        </div>


                       
                    </div>
                   
                </div>
                <Button color='success' style={{marginTop:'3%'}} onClick={submitInformation}>{submitText}</Button>
                <Button color='danger' onClick={()=>{setModal(false)}} style={{marginLeft:'2%',marginTop:'3%'}}>Close</Button>

            </div>
        </Modal>

        <Modal isOpen={modal2}>
            <ModalHeader>Submit information</ModalHeader>
            <div className="modalContainer">
                    <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Select Payment status" onChange={(e)=>{setIspay(e.target.value)}}>
                            <Form.Select  className='inputSearch'   type="text" >
                                <option selected disabled>Do you want to pay now?</option>
                                <option value={1}>YES</option>
                                <option value={0}>NO</option>
                            </Form.Select>
                    </FloatingLabel>

                    {isPay == 1 &&
                        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Enter MPESA Number" onChange={(e)=>{setMpesanumber(e.target.value)}}>
                            <Form.Control  className='inputSearch'   type="text" placeholder="Enter MPESA Number" />
                        </FloatingLabel>
                    
                    }
                    <Button color='success' onClick={submitInformation}>{payText}</Button>
                    <Button color='danger' onClick={()=>{setModal2(false)}} style={{marginLeft:'2%'}}>Close</Button>

            </div>
        </Modal>
        </div>
  )
}
